// OTP phone reducer

import * as types from '../actions/actionTypes';

const INITIAL_STATE = {
    token: null,
};

export default function otpPhoneReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.OTP_PHONE_RESET: {
            return { ...INITIAL_STATE };
        }

        case types.OTP_PHONE_SET_TOKEN: {
            const { token } = action;
            return {
                ...state,
                token: token || null,
            };
        }

        default:
            return state;
    }
}
